// extracted by mini-css-extract-plugin
module.exports = {"flag":"TranslationEditor_flag__328a1","clickable":"TranslationEditor_clickable__2uf0W"};